import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Actions
// @ts-ignore
import { editPerson } from 'services/people/actions';
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';

import {
    makeSelectQueryStringBooleanValue,
    makeSelectQueryStringNumberValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

// Global Components
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';
import PersonForm from 'components/PersonForm';
import { ADMIN, PAYROLL } from 'components/RoleGate/constants';

import { PersonModal } from '../../constants';

interface ConnectedProps {
    isOpen?: boolean;
    id?: number;
}

interface DispatchProps {
    editPerson: Function;
    updateQueryString: Function;
}

type IProps = ConnectedProps & DispatchProps;

export class PersonUpdateModal extends React.PureComponent<IProps> {
    handleClose = (): void => {
        this.props.updateQueryString({
            [PersonModal.PERSON_UPDATE_MODAL]: undefined,
            selectedPerson: undefined
        });
    };

    handleSubmit = (values: {}): void => {
        const { id } = this.props;
        this.props.editPerson(id, values);
    };

    render(): React.ReactElement | null {
        const { isOpen, id } = this.props;
        if (!id) {
            return null;
        }
        return (
            <RoleGate requiredRoles={[ADMIN, PAYROLL]}>
                <Modal
                    size="fullscreen"
                    open={isOpen}
                    centered={false}
                    onClose={this.handleClose}
                    closeIcon
                >
                    <ErrorBoundary
                        namespace="PersonUpdateModal"
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        <Modal.Header>Edit Person</Modal.Header>
                        <Modal.Content className="constrain-width">
                            <PersonForm
                                onClose={this.handleClose}
                                onSubmit={this.handleSubmit}
                                personId={id}
                            />
                        </Modal.Content>
                    </ErrorBoundary>
                </Modal>
            </RoleGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<AppState, {}, ConnectedProps>({
    isOpen: makeSelectQueryStringBooleanValue(PersonModal.PERSON_UPDATE_MODAL),
    id: makeSelectQueryStringNumberValue('selectedPerson')
});

export default connect(mapStateToProps, {
    editPerson,
    updateQueryString
})(PersonUpdateModal);
